import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify)

const opts = {
  theme: {
      themes: {
        light: {
          primary: '#6163E9',
          accent: 'hsl(174, 42%, 51%)',
        },
      },
  },
  icons: {
    iconfont: 'mdi',
  },
}

export default new Vuetify(opts)


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js